import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { db } from "../api/firebase";
import { subscribeGiftCardSummaries } from "../services/giftCardSummaryService";
import { getJourneyBySlug, summaryMatchesJourney } from "../constants/giftJourney";
import HomeGiftCard from "../components/HomeGiftCard";
import "../styles/home.css";
import "../styles/journey.css";

export default function Browse() {
  const { categorySlug } = useParams();
  const cfg = useMemo(() => getJourneyBySlug(categorySlug || "egift"), [categorySlug]);

  const [catalog, setCatalog] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!db) {
      setCatalog([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const unsub = subscribeGiftCardSummaries((all) => {
      setCatalog(all.filter((row) => summaryMatchesJourney(row, cfg.slug)));
      setLoading(false);
    });
    return () => unsub();
  }, [cfg.slug]);

  return (
    <div className="home-page browse-page">
      <div className="browse-head">
        <Link to="/" className="browse-back">
          ← All occasions
        </Link>
        <h1>{cfg.label}</h1>
        <p className="browse-sub">{cfg.description}</p>
      </div>

      <section
        className="home-firebase-catalog browse-firebase-only"
        aria-labelledby="browse-catalog-heading"
        data-source="firebase-gifts"
      >
        <div className="home-firebase-catalog-head">
          <div>
            <h2 id="browse-catalog-heading" className="home-firebase-catalog-title">
              Gift cards
            </h2>
            <p className="home-firebase-catalog-sub">
              {!db
                ? "Catalog service is currently unavailable."
                : loading
                  ? "Loading gift cards…"
                  : `${catalog.length} cards available for this occasion.`}
            </p>
          </div>
          {db && !loading && catalog.length > 0 && (
            <span className="home-firebase-pill">Live catalog</span>
          )}
        </div>

        {!db ? (
          <div className="home-empty home-empty--left">
            <h3>Service unavailable</h3>
            <p>We could not load cards right now. Please try again in a moment.</p>
          </div>
        ) : loading ? (
          <div className="home-catalog-skeleton" aria-hidden>
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="home-catalog-skel-card" />
            ))}
          </div>
        ) : catalog.length === 0 ? (
          <div className="home-empty home-empty--left">
            <h3>No active gift cards for this occasion</h3>
            <p>Please check back soon for new designs.</p>
          </div>
        ) : (
          <div className="home-firebase-grid">
            {catalog.map((row) => (
              <HomeGiftCard key={row.id} summary={row} occasionSlug={cfg.slug} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
